export default __webpack_public_path__ + "static/media/home-seo-agency-bg-03.e14f4738.jpg";